/**
 * Your data: everything this server keeps about your account, as a file; or the account
 * deleted (your password, or your email for an account without one, and a code with two-step
 * sign-in; refused while you are the last owner of a team).
 */
import { Show, createSignal, type JSX } from "solid-js";
import { downloadText } from "../shared/download";
import { ArmedButton } from "../shared/ui";
import { usePages } from "./context";

/** The data section. */
export function AccountData(): JSX.Element {
  const { accounts, server, go } = usePages();
  const [password, setPassword] = createSignal("");
  const [code, setCode] = createSignal("");
  const me = () => accounts.me(server);
  const exportIt = async () => {
    const data = await accounts.call(server, (a) => a.exportAccount());
    if (data) downloadText("knodal-account.json", `${JSON.stringify(data, null, 2)}\n`, "application/json");
  };
  const remove = async () => {
    if (await accounts.deleteAccount(server, password(), code() || undefined)) go({ page: "home" });
  };
  return (
    <section class="team-section" id="account-data">
      <h3>Your data</h3>
      <p class="small muted">Everything this server keeps about your account (it is sealed on the server: no one reads it in clear).</p>
      <button type="button" class="btn" id="account-export" onClick={() => void exportIt()}>
        Download my data
      </button>
      <h3>Delete the account</h3>
      <p class="small muted">Your teams keep their spaces; you leave them. Make someone else an owner of the teams you are the last owner of first.</p>
      <div class="row-inline">
        <input
          class="field"
          id="account-delete-password"
          type={me()?.has_password === false ? "email" : "password"}
          placeholder={me()?.has_password === false ? "your email, to confirm" : "your password"}
          value={password()}
          onInput={(e) => setPassword(e.currentTarget.value)}
        />
        <Show when={me()?.second_step}>
          <input class="field mono" id="account-delete-code" placeholder="code" inputmode="numeric" value={code()} onInput={(e) => setCode(e.currentTarget.value)} />
        </Show>
        <ArmedButton class="btn danger" id="account-delete" label="Delete my account" armedLabel="Click again to delete it for good" onConfirm={() => void remove()} />
      </div>
    </section>
  );
}
